import styles from './validation-error-tooltip.module.scss';
import classNames from 'classnames';
import ComponentAnimation, {
  AnimationTypes,
} from '../../general/component-animation/component-animation';

type ValidationErrorTooltipProps = {
  message: string | null | undefined;
  visible: boolean;
  hasNoArrow?: boolean;
};

export const ValidationErrorTooltip = ({
  message,
  visible,
  hasNoArrow,
}: ValidationErrorTooltipProps) => (
  <ComponentAnimation
    displayContentIf={visible}
    type={AnimationTypes.EXPAND_DOWN_AND_FADE_IN}
    id='validation-error-tooltip-animation'
  >
    <div
      role='alert'
      className={classNames(
        styles['validation-error-tooltip'],
        !hasNoArrow && styles['validation-error-tooltip__arrow'],
      )}
    >
      {message}
    </div>
  </ComponentAnimation>
);
